const CLOVER_OAUTH_PARAMS = {
  CLIENT_ID: `client_id`,
  MERCHANT_ID: `merchant_id`,
  EMPLOYEE_ID: `employee_id`,
  CODE: `code`,
  STATE: `state`
};

export { CLOVER_OAUTH_PARAMS };
